import { GRow } from '../datatable';
import { QueovalBase, QueovalDik, GQueovalDik, QueovalItem } from '../global';
import { CustomFileInfo } from '../global';
import { CatalogueEL, Chapter } from '../elearning';

export class ElearningModel extends QueovalBase {
  public KeyLog: string;
  public StockQueovalToken: string;
  public StockEstoreToken: string;
  public ChapterDetails: ChapterEstoreDetails;
  public EstoreCategoriesList: Array<CategoryEstore>;
  public EstoreLanguagesList: Array<LanguageData>;
  public SelectedPrivateClient: PrivateClientInfo;
  public AuthorPrivateClientList: Array<PrivateClientInfo>;
}
export class PrivateClientInfo {
  public PK: number;
  public Name_SOC: string;
  public Base_SOC: string;
  public AdresSOC: string;
}
export class EstoreToken {
  public EstoreDB: EstoreConnDB;
  public ApiInfo: ApiData;
  public AuthorKey: string;
  public CanPublishChapters: boolean;
  public CanPurchaseChapters: boolean;
  //////////public AuthorKey: string;
  //////////public EstoreDB: EstoreConnDB;
  //////////public ApiInfo: ApiData;
  //////////public Networks: NetworkData;
  //////////public IsExtraNet: boolean;
}
export class EstoreConnDB {
  public NameDB: string;
  public NameServer: string;
}
//////export class NetworkData {
//////  public Queoval: ApiData;
//////  public Extra: ApiData;
//////}
export class ApiData {
  public HttpEstoreAPI: string;
  public HttpStreamAPI: string;
}
export class EstoreModel extends QueovalBase {
  public EstoreToken: string;
  public EstoreTokenInfo: EstoreToken;
}

export class ChapterEstore {
  public Data: GRow;
  public DetailsData: GRow;
  //////public ModulesList: Array<ModuleEstore>;
  public LessonsList: Array<LessonEstore>;
  public CategoriesList: Array<CategoryEstore>;
}
//export class ModuleEstore {
//  public VastrBOV: string;
//  public Info_BOV: string;
//  public LessonsList: Array<LessonEstore>;
//}
export class LessonEstore {
  public Data: GRow;
  //public Module: string;
  public Order: string;
  public Document: MediaEstore;
  public Video: MediaEstore;
  public Test: QuestionnaireEstore;
  public Exercise: QuestionnaireEstore;
}
export class QuestionnaireEstore {
  public Data: GRow;
  public QuestionList: Array<QuestionEstore>;
}
export class QuestionEstore {
  public Data: GRow;
  public MediaList: Array<MediaEstore>;
  public ResponseList: Array<ReponseEstore>;
}
export class ReponseEstore {
  public Data: GRow;
  public MediaList: Array<MediaEstore>;
}
export class MediaEstore {
  public Data: GRow;
  public FileInfo: CustomFileInfo;
}

export class ChapterInfoData {
  public ID: number;
  public Ident: number;
  public TitreCHA: string;
  public ObjecCHA: string;
  public PhotoCHA: string;
  public ChapitreVersion: string;
  public Approved: Boolean;
  public Deleted: Boolean;
  public ImportDate: string;
  public AuthorName: string;
  public AuthorKey: string;
  public AuthorServer: string;
  public AuthorDB: string;

 // public KeepActualVersion: Boolean;

  public CategoriesList: Array<CategoryEstore>;
}

export class CategoryEstore {
  public ID: number;
  public Name: string;
  public Description: string;
  public Selected: boolean;
  public TotChapters: number;
  public CatalogueID: number;
  public CatalogueName: string;
}

export class CatalogueEstore {
  public ID: number;
  public Name: string;
  public Description: string;
  public Selected: boolean;
  public TotCategories: number;
}

export class CatalogueMenu extends CatalogueEstore {
  public CategorieList: Array<CategoryEstore>;
}

export class PurchasedChapter {
  public Ident: number;
  public IdES_CHA: number;
  public TitreCHA: string;
}

export class PurchasedChapterDetails {
  public ChapterID: number;
  public PurchaseDate: string;
  public Price: string;
  public PriceMode: string;
  public Details: ChapterListItem;
}

export class LanguageData {
  public ID: number;
  public Code: string;
  public Name: string;
}

export class VideoItem {
  public Ident: string;
  public Type: string;
  public FileName: string;
  public HttpVideo: string;
  public HttpPreviews: Array<string>;
  public Selected: boolean;
  public LessonTitle: string;
  public LessonIdent: number;
}

export class ChapterEstoreDetails {
  public ID: number;
  public Ident: number;
  public ChapitreVersion: string;
  public PriceSingle: string;
  public PriceFull: string;
  public PriceMonth: string;
  public ImportDate: string;
  public ImportHour: string;
  public CustomDescription: string;
  public CustomKeywords: string;
  public Approved: boolean;
  public Deleted: boolean;
  public CreatedByName: string;
  public CreatedByImage: string;
  public Language: string;
  public SelectedVideos: string;
  public CategoriesList: Array<CategoryEstore>;
  public VideoList: Array<VideoItem>;
  public KeepVersion: boolean;
  public AutorKey: string;
}


export class EstoreAuthorData {
  public ID: number;
  public Desc: string;
  public Key: string;
  public ServerDB: string;
  public NameDB: string;
  public EstoreAPIQT: string;
  public EstoreAPINT: string;
  public StreamAPIQT: string;
  public StreamAPINT: string;
  public IsExtraNet: boolean;
}

export class ChapterValidationModel extends QueovalBase {
  public InvalidChaptersList: Array<ChapterInfoData>;
  public FilterAuthors: Array<string>;
  public FilterCategories: Array<CategoryEstore>;
  public EstorePackChaptersList: Array<BaseChpaterEstorePack>;
  public ChaptersByState: Array<GQueovalDik<string, Array<ChapterInfoData>>>;
  public EstoreChapter: ChapterEstore;
  public Videos: Array<VideoItem>;
  public AuthorBaseName: string;
  public ImagePath: string;
  public EstoreChapterDetails: ChapterEstoreDetails;
  public EstoreLanguagesList: Array<LanguageData>;
}

export class ValidationModel extends QueovalBase {
  public AuthorInfo: EstoreAuthorData;
  public ElearningChapterDetails: ChapterEstoreDetails;
  public EstoreCategoriesList: Array<CategoryEstore>;
  public InvalidChaptersList: Array<ChapterInfoData>;
  public ChapterDetails: ChapterEstore;
  public FilterAuthors: Array<string>;
  public FilterCategories: Array<CategoryEstore>;

  public AuthorBaseName: string;
  public ImagePath: string;

  // estore id for imported chapter (publish process only)
  public ImportedChapterID: number;
  // queoval ident for imported chapter (publish process only)
  public ImportedChapterIdent: number;
}

export class ValidationModelNT extends QueovalBase {
  public AuthorInfo: EstoreAuthorData;
  public ElearningChaptersList: Array<ChapterEstoreDetails>;
  // public ImportDataList: Array<SavedImportData>;
}

export class EstoreImportModel extends QueovalBase {
  public InputChaptersList: Array<ChapterEstoreDetails>;
}

export class EstoreExportModel extends QueovalBase {
  public InputChaptersList: Array<ChapterListItem>;
}

export enum AlertMode {
  WARNING,
  ALERT,
  SUCCESS
}

export enum EstoreRole {
  AUTHOR,
  CENTREFORMATION,
  STAGIAIRE,
  VALIDATOR
}

export class EstoreRights {
  // Droit d'accès à l'application
  AccesApp: boolean;
  // Droit d'accès à publier du contenu
  PublishContent: boolean;
  // Droit d'accès à telecharger du contenu
  DownloadContent: boolean;
  constructor() {
    this.AccesApp = false;
    this.PublishContent = false;
    this.DownloadContent = false;
  }
}

export class UserRoles {
  public Droits: EstoreRights;
  public IsValidator: boolean;
  public CanPurchaseChapters: boolean;
  public PurchasedChapterList: Array<PurchasedChapter>;
  //////get IsAdmin(): boolean {
  //////  // is admin when all of the roles are true
  //////  return this.CanConnectElearning && this.CanEditLessonsElearning && this.CanEditLearnersLicense && this.CanConfigureElearning;
  //////}

  constructor() {
    this.Droits = new EstoreRights();
    this.IsValidator = false;
    this.CanPurchaseChapters = false;
    this.PurchasedChapterList = [];
  }
}

//#region HOME PAGE
export class HomeModel extends QueovalBase {
  public Menu: Array<CatalogueMenu>;
  public Authors: Array<EstoreAuthorData>;
  public AuthorInfo: EstoreAuthorData;

  public Cart: ShoppingCart;
  public AppParamKeys: Array<QueovalDik>;
  public UserPurchasedList: Array<PurchasedChapter>;
  public UserIP: string;
  public CanPurchaseChapters: boolean;
  public LastAddedChapters: Array<ChapterListItem>;
}
//#endregion

//#region GET CATALOGUES/CATEGORIES & AUTHORS MANAGEMENT PAGE
export class CataloguesModel extends QueovalBase {
  public CataloguesList: Array<CatalogueEstore>;
  public SelectedCatalogue: CatalogueEstore;
}

export class CategoriesModel extends QueovalBase {
  public CategoriesList: Array<CategoryEstore>;
  public CataloguesList: Array<CatalogueEstore>;
  public SelectedCategory: CategoryEstore;
}

export class AuthorsModel extends QueovalBase {
  public AuthorsList: Array<EstoreAuthorData>;
}
//#endregion

//#region ADMIN CHAPTERS MANAGEMENT PAGE
export class ChapterAdminModel extends QueovalBase {
  public ChaptersList: Array<ChapterListItem>;
  public CategoriesList: Array<CategoryEstore>;
  public EstoreLanguagesList: Array<LanguageData>;
  public SelectedChapter: ChapterListItem;
  public ChapterVideosList: Array<VideoItem>;
  public ChapterLessonsList: Array<LessonAdmin>;
  public SelectedCategoriesJoin: string;
}

export class LessonAdmin {
  public ID: number;
  public TitreCON: string;
  public ResolCON: string;
  public Selected: boolean;
  public HasChanged: boolean;
}
//#endregion

//#region IMPORT LIST PAGE
export class ImportListModel extends QueovalBase {
  public ListCatalogueEL: Array<CatalogueEL>;
  public ListChapterEL: Array<Chapter>;
}
//#endregion

//#region CHAPTERS LIST
export class ChaptersListModel extends QueovalBase {
  public ChaptersList: Array<ChapterListItem>;
  public FilterAuthors: Array<string>;
}

export class ChapterListItem {
  public ID: number;
  public Ident: number;
  public TitreCHA: string;
  public DescrCHA: string;
  public TempsCHA: string;
  public PhotoCHA: string;
  public ChapitreVersion: string;
  public PriceSingle: string;
  public PriceFull: string;
  public PriceMonth: string;
  public Language: string;
  public LanguageCode: string;
  public CustomDescription: string;
  public CustomKeywords: string;
  public CreatedByName: string;
  public CreatedByImage: string;
  public CreatedByImageBase: string;
  public CustomImage: string;
  public AuthorAddress: string;
  public AuthorName: string;
  public AuthorServer: string;
  public AuthorDB: string;
  public ImportDate: string;
  public ValidationDate: string;
  public SelectedPrice: string;
  public SelectedPriceMode: string;
  public Tot: ChapterTotals;
  public ShowVideos: string;
  public Videos: Array<VideoItem>;
  public ChapterCategories: Array<ChapterCategory>;
}
//#endregion

//#region CHAPTER DETAILS

export class ChapterDetailsModel extends QueovalBase {
  public ChapterDetails: ChapterEstore;
  public ChapterImagePath: string;
}
//#endregion


export class ChapterTotals {
  public CountLessons: number;
  public CountExercises: number;
  public CountTests: number;
  public CountVideos: number;
  public CountDocs: number;
}

export class ChapterCategory {
  public ID: number;
  public Description: string;
}

export class ChapterPrice {
  public Price: string;
  public PriceMode: string;
  constructor(price: string, mode: string) {
    this.Price = price;
    this.PriceMode = mode;
  }
}

export class ShoppingCart {
  public ID: number;
  public BuyerId: number;
  public BuyerBase: string;
  public BuyerServer: string;
  public CreationDate: string;
  public CreationTime: string;
  public Price: string;
  public ListChapitres: Array<ChapterListItem>;
}

export class ShoppingCartModel extends QueovalBase {
  public Cart: ShoppingCart;
  public AuthorInfo: EstoreAuthorData;
}

export class EmptyModel {
  public jsonData: string;
  public isRedirect: boolean;
  public redirectPage: string;
}


//#region LUCENE SEARCH

export class SearchChapter {
  public ID: number;
  public TitreCHA: string;
  public DescrCHA: string;
}
export class SearchDetailChapter {
  public ID: number;
  public ChapitreId: number;
  public CustomDescription: string;
  public CustomKeywords: string;
}
export class SearchCategory {
  public ID: number;
  public ChapitreId: number;
  public Name: string;
  public Description: string;
}

export class LuceneSearchModel {
  public ChaptersList: Array<SearchChapter>;
  public DetailsList: Array<SearchDetailChapter>;
  public CategoriesList: Array<SearchCategory>;
}

export class SearchItem {
  public ID: number;
  public TitreCHA: string;
  public DescrCHA: string;
  public PhotoCHA: string;
  public CustomTotals: string;
  public CustomDescription: string;
  public PriceSingle: string;
  public PriceFull: string;
  public PriceMonth: string;  public DbNomAUT: string;
  public Tot: ChapterTotals;
}

export class SearchModel extends QueovalBase {
  public SearchItemList: Array<ChapterListItem>;
  public SearchResultList: Array<ChapterListItem>;
  public SearchResultCategories: Array<ChapterCategory>;
  //////public IndexFilePath: string;
  //////public SearchModel: LuceneSearchModel;
  //////public SearchMode: string;
  public SearchText: string;
  //////public DefaultSearch: boolean;
  //////public ChaptersList: Array<SearchChapter>;
  //////public DetailsList: Array<SearchDetailChapter>;
  //////public CategoriesList: Array<SearchCategory>;
  //////public ChapterDetails: SearchItem;
}

//#endregion

//#region HISTORY

export class TrackHistoryModel extends QueovalBase {
  public TrackData: TrackItem;
  public TrackItemsList: Array<TrackItem>;
  public TrackedList: Array<TrackDTO>;
}
export class TrackItem {
  public EstoreID: string;
  public Ident: string;
  public BaseFrom: string;
  public BaseTo: string;
  public DataContent: string;
  public RegistredDate: string;
  public ChapitreVersion: string;
  public CustomDescription: string;
  public ConnectedUser: string;
}

export class TrackDTO {
  public ID: number;
  public Code: string;
  public Description: string;
  public BaseFrom: string;
  public BaseTo: string;
  public DataContent: string;
  public RegistredDate: Date;
  public RegistredDateString: string;
  public RegistredTimeString: string;
  public User: string;
}
//#endregion


export class SnapshotData {
  public ID: number;
  public Code_IMG: string;
  public TitleIMG: string;
  public DescrIMG: string;
  public Path_IMG: string;
  public Link_IMG: string;
  public CssIndex: string;
  public CssClass: string;
  public Changed: boolean;
  public SelectedFileName: string;

  public file: File | null;
}

export class PicturesModel extends QueovalBase {
  public OnlyLink: boolean;
  public BannerList: Array<SnapshotData>;
  //////public ThemesList: Array<SnapshotData>;
  public SelectedBanner: SnapshotData;
  public SelectedChapter: SnapshotData;
}


export class EstoreLicenseModel extends QueovalBase {
  public EstoreBDD: string;
  public EstoreSRV: string;
  public EnvironmentList: Array<EnvironmentEstore>;
  public EnvironmentListSql: Array<EnvironmentEstore>; 
  public SelectedEnvironment: EnvironmentEstore;
  public ClientDatabase: string;
  public EstoreAPI: string;
  public StreamAPI: string;
  public CreateAuthorKey: boolean;
  public AuthorKey: string;
  public AuthorInfo: EstoreAuthorData;
  public License: Array<LicenseData>;
}

//////////export class EstoreNetworkInfo {
//////////  public EstoreAPI: string;
//////////  public StreamAPI: string;
//////////}
export class EnvironmentEstore {
  public Name: string;
  public Description: string;
  public InstanceDB: string;
  public EstoreAPI: string;
  public StreamAPI: string;
}
export class LicenseData {
  public Code_APL: string;
  public ZstriAPL: string;
  public Info_APL: string;
}

export class ClienDataValidationModel {
  public Log: string;
}



export class ChapterInfo {
  public ClientIdent: string;
  public EstoreID: string;
  public LessonList: Array<LessonInfo>;
}
export class LessonInfo {
  public ClientIdent: string;
  public EstoreID: string;
  public Document: MediaInfo;
  public Video: MediaInfo;
  public TestLesson: QuestionnaireInfo;
  public ExerciseLesson: QuestionnaireInfo;
}
export class QuestionnaireInfo {
  public ClientIdent: string;
  public EstoreID: string;
  public QuestionList: Array<QuestionInfo>;
}
export class QuestionInfo {
  public ClientIdent: string;
  public EstoreID: string;
  public MediaList: Array<MediaInfo>;
  public ResponseList: Array<ReponseQuestionInfo>;
}
export class ReponseQuestionInfo {
  public ClientIdent: string;
  public EstoreID: string;
  public MediaList: Array<MediaInfo>;
}
export class MediaInfo {
  public ClientIdent: string;
  public EstoreID: string;
}
export class ChapterInfoModel extends QueovalBase {
  public ActionSecurityCode: string;
  public ChapterID: string;
  public ChapterIdent: string;
  public Chapter: ChapterInfo;
  public DeleteResult: number;
}

export class ModelIP {
  public ip: string;
}

export class BaseChpaterEstorePack {
  public Ident: string;
  public IdES_CHA: string;
  public AuthKCHA: string;
}

export class EstoreTarifData {
  public BaseName: string;
  public Ident: number;
  public TitleChap: string;
  public Percentage: number;
  public NomApLMT: string;
  public PreAPLMT: string;
  public IdeApLMT: number;
  public IdAutLMT: number;
  public Prix_LMT: string;
  public Date_LMT: string;
  public Mode_LMT: string;
}

export class EstoreTarifGroup {
  public Key: string;
  public TarifDataList: Array<EstoreTarifData>;
}

export class EstoreApprenantsModel extends QueovalBase {
  public DateFromUTC: string;
  public DateToUTC: string; 
  public TarifGroupList: Array<EstoreTarifGroup>;
}

export class EstoreAuthorModel extends QueovalBase {
  public ContactID: string;
  public ContactNameDB: string;
  public ContactAuthorKey: string;
  public Rate: number;
  public DateFromUTC: string;
  public DateToUTC: string;
  public BuyersList: Array<EstoreBuyer>;
  public SelectedBuyer: EstoreBuyer;
  public SelectedBuyerTarif: EstoreTarifGroup;
}
export class SoldChapters {
  public ID: number;
  public ChapterID: number;
  public CustomerBase: string;
  public CustomerIdent: number;
  public PurchaseDate: Date;
  public Price: number;
  public PriceMode: string;
}
export class EstoreBuyer {
  public ClientDB: string;
  public SoldChaptersList: Array<SoldChapters>;
}
